import ApiService from './ApiService';

const ObtenerDescripcionAlcancesDelPlan = (data) => {
    return ApiService.get(`${process.env.REACT_APP_APIPAYWALL}CambioPlanV1/obtenerDescripcionAlcansesDelPlan`, data);
};

export default ObtenerDescripcionAlcancesDelPlan;
